var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ol',{staticClass:"material-design-steps",attrs:{"id":_vm.id}},[_vm._t("default",null,{"value":_vm.value})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }